import { createSlice } from "@reduxjs/toolkit";
const initialState = localStorage.getItem("AUTH-TOKEN")
  ? JSON.parse(localStorage.getItem("AUTH-TOKEN"))
  : {
      token: null,
      userid: null,
    };

export const RS_Tokens = createSlice({
  name: "rs-authentication",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload.token;
      state.userid = action.payload.userid;
    },
    revokeToken: (state) => {
      return {
        token: null,
        userid: null,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { setToken, revokeToken } = RS_Tokens.actions;

export default RS_Tokens.reducer;
